import { render, staticRenderFns } from "./CommitteeConfigModal.vue?vue&type=template&id=afad4c48&scoped=true"
import script from "./CommitteeConfigModal.vue?vue&type=script&lang=js"
export * from "./CommitteeConfigModal.vue?vue&type=script&lang=js"
import style0 from "./CommitteeConfigModal.vue?vue&type=style&index=0&id=afad4c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afad4c48",
  null
  
)

export default component.exports